import { render, staticRenderFns } from "./SamplePsiMutation.vue?vue&type=template&id=d6ec16fa&scoped=true&"
import script from "./SamplePsiMutation.vue?vue&type=script&lang=js&"
export * from "./SamplePsiMutation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6ec16fa",
  null
  
)

export default component.exports